var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.1348 51.1976V6.86422C62.1348 3.38088 59.0348 0.530884 55.2459 0.530884H7.02365C3.23477 0.530884 0.134766 3.38088 0.134766 6.86422V51.1976C0.134766 54.6809 3.23477 57.5309 7.02365 57.5309H55.2459C59.0348 57.5309 62.1348 54.6809 62.1348 51.1976ZM20.457 35.3009L27.6903 43.3126L38.3681 30.6776C39.057 29.8542 40.4348 29.8542 41.1237 30.7092L53.2137 45.5292C53.4056 45.7645 53.5224 46.0442 53.5511 46.337C53.5799 46.6299 53.5193 46.9243 53.3763 47.1873C53.2332 47.4503 53.0134 47.6715 52.7413 47.8261C52.4692 47.9807 52.1557 48.0626 51.8359 48.0626H10.537C9.09032 48.0626 8.2981 46.5426 9.19366 45.4976L17.7703 35.3642C18.4248 34.5409 19.7337 34.5092 20.457 35.3009Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImgPlaceholder);
export default __webpack_public_path__ + "static/media/upload_img_placeholder.f1013dbe7687ba5f908db234fac81b00.svg";
export { ForwardRef as ReactComponent };